document.addEventListener('DOMContentLoaded', function() {
  var productGrids = document.querySelectorAll('.grid.product-grid');

  productGrids.forEach(function(productGrid) {
    var sectionId = productGrid.getAttribute('data-section-id');
    var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];

    // Set the default variant details on page load for each product
    var initialVariantInputs = productGrid.querySelectorAll('input[type="radio"]:checked');
    initialVariantInputs.forEach(function(initialVariantInput) {
      var selectedProductId = initialVariantInput.getAttribute('data-product-id');
      updateVariantDisplay(initialVariantInput, sectionId, selectedProductId);
    });

    productGrid.addEventListener('change', function(e) {
      if (e.target.matches('input[type="radio"][data-section-id="' + sectionId + '"]')) {
        var selectedProductId = e.target.getAttribute('data-product-id');
        updateVariantDisplay(e.target, sectionId, selectedProductId);

        var card = e.target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
        var variantId = e.target.getAttribute('data-variant-id');
        var variantData = variantDataMap[variantId];

        if (!variantData) {
          console.log('No data found for variant:', variantId);
          return;
        }

        // Update the product image and URL only for the selected product
        var productImageElement = card.querySelector('.card__media img');
        if (productImageElement) {
          updateProductImage(productImageElement, variantId, variantData, card);
        } else {
          console.log('No product image element found in this card.');
        }
        updateProductLinks(card, variantData);
      }
    });
  });

  function updateVariantDisplay(inputElement, sectionId, selectedProductId) {
    // Hide all variant value display elements for the selected product
    var allVariantValueDisplays = document.querySelectorAll(`[id^="variant-value-display-${sectionId}-${selectedProductId}-"]`);
    allVariantValueDisplays.forEach(function(display) {
      display.style.display = 'none';
    });

    // Show the selected variant value display element
    var selectedVariantValueDisplayId = `variant-value-display-${sectionId}-${selectedProductId}-${inputElement.getAttribute('data-option-position')}-${inputElement.getAttribute('data-index')}`;
    var selectedVariantValueDisplay = document.getElementById(selectedVariantValueDisplayId);
    if (selectedVariantValueDisplay) {
      selectedVariantValueDisplay.textContent = inputElement.value;
      selectedVariantValueDisplay.style.display = 'block';
    }

    var productFormVariantInput = document.querySelector('.product-form-variant-id[data-product-id="' + selectedProductId + '"]');
    if (productFormVariantInput) {
      productFormVariantInput.value = inputElement.getAttribute('data-variant-id');
    }

    // Update the variant description
    var selectedVariantId = inputElement.getAttribute('data-variant-id');
    var variantDescriptionElements = document.querySelectorAll(`[id^="variant-description-${sectionId}-${selectedProductId}-"]`);
    variantDescriptionElements.forEach(function(element) {
      element.style.display = 'none';
    });

    var selectedVariantDescriptionElement = document.querySelector(`#variant-description-${sectionId}-${selectedProductId}-${inputElement.getAttribute('data-option-position')}-${inputElement.getAttribute('data-index')}`);
    if (selectedVariantDescriptionElement) {
      selectedVariantDescriptionElement.style.display = 'block';
    }
  }

  function updateProductImage(productImageElement, variantId, variantData, card) {
    var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';

    if (lazyLoadAllVariants) {
      var preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
      if (preloadedImage) {
        productImageElement.src = preloadedImage.src;
        productImageElement.srcset = preloadedImage.srcset;
      } else {
        console.log('Matching preloaded image not found for variant:', variantId);
      }
    } else {
      var dynamicSrcset = [
        variantData.imageUrl + '?width=165 165w',
        variantData.imageUrl + '?width=360 360w',
        variantData.imageUrl + '?width=533 533w',
        variantData.imageUrl + '?width=720 720w',
        variantData.imageUrl + '?width=940 940w',
        variantData.imageUrl + '?width=1066 1066w'
      ].join(', ');
      productImageElement.srcset = dynamicSrcset;
      productImageElement.src = variantData.imageUrl;
    }
  }

  function updateProductLinks(card, variantData) {
    var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
    productLinks.forEach(function(link) {
      link.href = variantData.productUrl;
    });
  }
});